module Meevo.Plugins.Controls {

    declare let d3: any;

    export interface ILineChartDataRow {
        values: {
            x: number;
            y: number;
        }[];
        key: string;
        color: string;
        strokeWidth?: number;
        classed?: string;
    }


    class MeevoLineChartComponent<T> extends BaseChart<T, ILineChartDataRow> {
        static $inject = ['$scope', '$element', '$timeout'];

        public options: Object;

        constructor($scope, $element, $timeout) {
            super($scope, $element, $timeout);

            this.options = {
                chart: {
                    type: 'lineChart',
                    height: 450,
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 40,
                        left: 55
                    },
                    x: function (d) {
                        return d.x;
                    },
                    y: function (d) {
                        return d.y;
                    },
                    useInteractiveGuideline: true,
                    dispatch: {
                        stateChange: function (e) {
                            console.log('stateChange');
                        },
                        changeState: function (e) {
                            console.log('changeState');
                        },
                        tooltipShow: function (e) {
                            console.log('tooltipShow');
                        },
                        tooltipHide: function (e) {
                            console.log('tooltipHide');
                        }
                    },
                    xAxis: {
                        axisLabel: 'Time (ms)'
                    },
                    yAxis: {
                        axisLabel: 'Voltage (v)',
                        tickFormat: function (d) {
                            return d3.format('.02f')(d);
                        },
                        axisLabelDistance: -10
                    },
                    callback: function (chart) {
                        console.log('!!! lineChart callback !!!');
                    }
                }
            };
        }
    }


    angular.module('meevo.components.controls')
        .component('meevoLineChartComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/charts/line-chart/line-chart.html',
            controller: MeevoLineChartComponent,
            controllerAs: '$ctrl',
            bindings: {
                title: '@',
                inputData: '<',
                mapFn: '='
            }
        });
}
